import {
    COMPETITION_SECRETARY_DELETE_REQUEST,
    COMPETITION_SECRETARY_DELETE_FAILURE,
    COMPETITION_SECRETARY_DELETE_SUCCESS,
} from 'actions';

const initialState = {
    deleting: false,
    hasErrors: false,
};

export const competitionSecretaryDeleteReducer = (state = initialState, action) => {
    const {type} = action;
    switch (type) {
        case COMPETITION_SECRETARY_DELETE_SUCCESS: {return {
            ...state,
            deleting: false,
            hasErrors: false,
        }}

        case COMPETITION_SECRETARY_DELETE_REQUEST: {return {
            ...initialState,
            deleting: true,
        }}

        case COMPETITION_SECRETARY_DELETE_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
